module.exports = __webpack_public_path__ + "media/images/integrated-payments-3-6efc6d97823ba8e001e609b44ab38dc7.svg";